'use strict';

var bornModules = require('../../helpers/born.modules').default,
    ajax = require('../../ajax'),
    // tooltip = require('../../tooltip'),
    util = require('../../util');

module.exports = function () {
    var $addToCart = $('.product-set-list #add-to-cart'),
        $addAllToCart = $('#add-all-to-cart'),
        $productSetList = $('#product-set-list');

    var updateAddToCartButtons = function () {
        if ($productSetList.find('.add-to-cart[disabled]').length > 0) {
            $addAllToCart.attr('disabled', 'disabled');
            // product set does not have an add-to-cart button, but product bundle does
            $addToCart.attr('disabled', 'disabled');
        } else {
            $addAllToCart.removeAttr('disabled');
            $addToCart.removeAttr('disabled');
        }
    };

    if ($productSetList.length > 0) {
        updateAddToCartButtons();
    }

    function loadOption(url) {
        var $container = $(this).closest('.product-set-item');
        var qty = $container.find('form input[name="Quantity"]').first().val();

        ajax.load({
            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
            target: $container,
            callback: function () {
                updateAddToCartButtons();
                bornModules.selectTags.init();
                // tooltip.init();
            }
        });
    }

    // click on swatch for product set
    $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
        e.preventDefault();
        if ($(this).closest('.unselectable').length) { return; }
        
        var url = Urls.getSetItem + this.search;
       
        loadOption.call(this, url);
    });

    $productSetList.on('change', '.product-set-item .variation-select', function () {
        if ($(this).val().length === 0) { return; }
        
        var url = Urls.getSetItem + '?' + util.getQueryString(this.value);
        // console.log(util.getQueryString(this.value));

        loadOption.call(this, url);
    });
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/product/productSet.js